export const RegionData = {
"region_1" : "RO-CHE",
"region_2" : "HO-MUM (M)",
"region_3" : "RO-SRT",
"region_4" : "RO-JAI",
"region_5" : "RO-KOL",
"region_6" : "RO-DEL",
}